import { BanknotesIcon, CreditCardIcon } from '@heroicons/react/24/outline';
import { PaymentType } from '@/types-aggregatore';
import { ELBadge } from '@davincihealthcare/elty-design-system-react';

type PaymentsProps = {
  paymentsList: PaymentType[];
};

const Payment = ({
  LeadingIcon,
  label,
  additional,
}: {
  LeadingIcon: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
      title?: string | undefined;
      titleId?: string | undefined;
    } & React.RefAttributes<SVGSVGElement>
  >;
  label: string;
  additional: string;
}) => (
  <div className="inline-flex items-center gap-x-4">
    <ELBadge Icon={LeadingIcon} color="secondary" size="small" applyNativeSVGSize />
    <div className="flex flex-col">
      <h4 className="text-base font-semibold text-neutral-darker">{label}</h4>
      <span className="text-sm font-normal text-neutral-lighter">{additional}</span>
    </div>
  </div>
);

const Payments = ({ paymentsList }: PaymentsProps) => {
  return (
    <div className="grid grid-cols-1 gap-y-4 self-start" data-cy="profile payments">
      <h3 className="text-xs font-semibold text-neutral-lighter lg:text-base lg:font-medium">Modalità di pagamento</h3>
      {paymentsList.map((item, index) => {
        switch (item) {
          case PaymentType.Online: {
            const label = 'Pagamento Online';
            const additional = 'Carta di credito, Carta di debito';
            return <Payment LeadingIcon={CreditCardIcon} label={label} additional={additional} key={index} />;
          }
          case PaymentType.Onsite: {
            const label = 'Pagamento in sede';
            const additional = 'Contanti, Carta di credito, Carta di debito';
            return <Payment LeadingIcon={BanknotesIcon} label={label} additional={additional} key={index} />;
          }
        }
      })}
    </div>
  );
};

export default Payments;
